import React from 'react'
// import AboutSection from '../AboutSection'
import Hero from '../hero/Hero'
import PostHeroSection from '../PostHeroSection'
import Servicegrid from '../Servicesgrid/Servicegrid'
import Ourproduct from '../ourproduct/Ourproduct'
// import Testimonials from '../Testimonials'

function Home() {
  return (
    <>
    <Hero></Hero>    
    <Servicegrid></Servicegrid>
    <Ourproduct></Ourproduct>
    </>
  )
}

export default Home
